import * as React from "react";
import ButtonLanding from "../ButtonLanding.primitive";
interface IButton {
  label: string;
  onClick: (value: any) => any;
  errorMessage?: string;
  isLoading?: boolean;
}
function ModalFooter2({ buttons }: { buttons: IButton[] }) {
  if (buttons.length == 0) {
    return <div />;
  }
  let classNameButtonContainer = getClassNameButtonContainer(buttons.length);
  return (
    <div className="row mobile-padding-bottom margin-bottom-m">
      {buttons.map((button, index) => (
        <div className={classNameButtonContainer} key={index}>
          <div className="text-center margin-top-m-fixe">
            <ButtonLanding
              text={button.label}
              nextPage={button.onClick}
              isLoading={button.isLoading}
              errorMessage={button.errorMessage}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

function getClassNameButtonContainer(nbButtons) {
  var className = "col-md-6";
  switch (nbButtons) {
    case 1:
      className = "col-xs-12";
      break;

    case 2:
      className = "col-xs-6";
      break;

    case 3:
      className = "col-xs-4";
      break;

    case 4:
      className = "col-xs-3";
      break;

    default:
      className = "col-xs-6";
      break;
  }

  return className;
}

export default ModalFooter2;



// WEBPACK FOOTER //
// ./assets/react/views/primitive/modal/ModalFooter2.primitive.tsx